import { Flex } from "@chakra-ui/react"
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"
import { useState } from "react"

import Navbar from "@/components/layout/Common/Navbar"
import Sidebar from "@/components/layout/Common/Sidebar"
import { useAuthStore } from "@/stores/auth"

export const Route = createFileRoute("/_layout")({
  component: Layout,
  beforeLoad: async () => {
    const { isAuthenticated, accessToken, clearAuth } = useAuthStore.getState()

    // Check if user is authenticated with a valid access token
    if (isAuthenticated && accessToken) {
      return
    }

    // If not authenticated, clear any stale state and redirect to login
    if (!isAuthenticated || !accessToken) {
      clearAuth()
      throw redirect({
        to: "/login",
      })
    }
  },
})

function Layout() {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)

  return (
    <Flex direction="column" h="100vh">
      <Navbar onMenuToggle={() => setMobileSidebarOpen(true)} />
      <Flex flex="1" overflow="hidden">
        <Sidebar
          mobileOpen={mobileSidebarOpen}
          onMobileOpenChange={setMobileSidebarOpen}
        />
        <Flex
          flex="1"
          direction="column"
          p={{ base: 2, md: 3, lg: 4 }}
          overflowY="auto"
          minW="0"
        >
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default Layout
